import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const SLOT_SERVICES = ["spa", "barber", "washingbay"];

export default function SlotPicker({ service, date, value, onChange }) {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!SLOT_SERVICES.includes(service) || !date) {
      setSlots([]);
      return;
    }
    setLoading(true);
    api
      .get(`/slots/availability?service=${service}&date=${date}`)
      .then((r) => setSlots(r.data.uses_slots ? r.data.slots : []))
      .finally(() => setLoading(false));
  }, [service, date]);

  if (!SLOT_SERVICES.includes(service)) return null;
  if (!date) {
    return <p className="text-xs text-black/50">Pick a date above to see available time slots.</p>;
  }
  if (loading) return <p className="text-xs text-black/50 font-mono">Loading slots…</p>;

  return (
    <div>
      <label className="label-eyebrow block mb-3">Available time slots — {date}</label>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2" data-testid="slot-picker">
        {slots.map((s) => {
          const isPicked = value === s.time;
          const disabled = !s.available;
          return (
            <button
              type="button"
              key={s.time}
              disabled={disabled}
              onClick={() => onChange(s.time)}
              data-testid={`slot-${s.time}`}
              className={`border text-sm py-3 px-2 transition-colors text-center ${
                isPicked
                  ? "bg-black text-white border-black"
                  : disabled
                  ? "bg-neutral-100 text-black/30 border-black/10 cursor-not-allowed line-through"
                  : "bg-white text-black border-black/30 hover:bg-black hover:text-white"
              }`}
            >
              <div className="font-mono text-sm">{s.time}</div>
              <div className="text-[10px] mt-1 opacity-70">
                {disabled ? "Full" : `${s.capacity - s.booked} left`}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
